import { X, LogOut } from 'lucide-react';
import { Button } from './Button';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const LogoutModal = ({ isOpen, onClose, onConfirm }: LogoutModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-[16px] shadow-xl max-w-sm w-full overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-[#E5E7EB]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#FEF2F2] rounded-full flex items-center justify-center">
              <LogOut className="w-5 h-5 text-[#DC2626]" />
            </div>
            <h3 className="font-bold text-[#111827]">Cerrar sesión</h3>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <X className="w-5 h-5 text-[#6B7280]" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-[#6B7280]">
            ¿Seguro que deseas cerrar sesión?
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 p-4 border-t border-[#E5E7EB]">
          <Button
            onClick={onClose}
            variant="secondary"
            className="flex-1"
          >
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            variant="primary"
            className="flex-1"
          >
            Sí, cerrar sesión
          </Button>
        </div>
      </div>
    </div>
  );
};
